<template>
  <div class="app">
    <!-- <my-canal-header></my-canal-header> -->
    <transition name="slide">
      <div v-for="error in errors" :key="error" class="e-paragraph app__errors">Une erreur s'est produite: {{ error }}</div>
    </transition>
    <app-hero>
      <transition name="fade">
        <div v-if="!loaded" class="app__loading">
          <spinner class="app__spinner"></spinner>
        </div>
      </transition>
      <!-- <div class="app__heroContainer heroContent"> -->
      <img class="app__logo" src="images/logo.svg" alt="">
      <h1 class="e-h1-canal u-color-pink app__title">{{ title }}</h1>
      <!-- <p class="u-color-black app__intro e-paragraph" v-html="text" /> -->
      <!-- <p v-if="$route.path !== '/voted' && $route.path !== '/ended'" class="e-h2-canal app__voteText">Les séries en compétition</p> -->
        <!-- <h1 class="app__title e-h1 slide-left">SAISON<br><span>03</span></h1>
        <div class="app__heroContent heroContent">
        <div class="heroContent__titleBlock">
          <div class="heroContent__blocks">
            <div class="heroContent__public slide-up"><p class="e-h2">Prix du public</p></div>
            <div class="heroContent__best slide-up"><p class="e-h3">Meilleure nouvelle<br>série francaise</p></div>
            <p class="u-color-black heroContent__hashtag--mobile e-h2">#canneseries</p>
          </div>
        </div>
        <div class="heroContent__dateBlock">
          <p class="e-h2 u-color-black slide-left">09 au 14</p>
          <p class="e-h2 u-color-black slide-left">octobre </p>
          <p class="e-h2 u-color-black slide-left">2020</p>
          <p class="e-h2 heroContent__hashtag--desktop slide-left">#canneseries</p>
        </div> -->
        <!-- </div> -->
      <!-- </div> -->
      <!-- <div v-if="$router.currentRoute.name === 'home'" @click="goToVotes" class="heroContent__scroll e-paragraph">
        Voter
        <div class="heroContent__arrow"></div>
      </div> -->
    </app-hero>
    <content-wrapper>
      <!-- <section ref="paragraph" class="app__textContent">
        <p id="votes" class="e-paragraph paragraph1 will-appear" v-observable="{treshold: .0,callback: () => entered('paragraph1')}">
        A l’occasion de la 3<sup>ème</sup> édition de CANNESERIES, Festival International des Séries de Cannes qui se tiendra <b>du 09 au 14 octobre prochain</b>, votez pour votre série préférée parmi les nouvelles séries françaises de l’année.
      </p>
      <p class="e-paragraph paragraph2 will-appear" v-observable="{treshold: .0,callback: () => entered('paragraph2')}">
        <b>La série gagnante sera révélée le 14 octobre</b> lors de la cérémonie de clôture à Cannes.
      </p>
      </section> -->
      <transition name="fade-in-out">
        <router-view class="router" v-if="loaded"></router-view>
      </transition>
      <div class="app__partner">
        <p class="e-paragraph">En partenariat avec </p><img height="45px" src="/images/allo.png" alt="Allo ciné">
      </div>
    </content-wrapper>
    <my-canal-footer></my-canal-footer>
  </div>
</template>

<script>
import gsap from 'gsap';
import MyCanalFooter from './components/shell/my-canal-footer';
// import MyCanalHeader from './components/shell/my-canal-header';
import AppHero from './components/shell/app-hero';
import ContentWrapper from './components/shell/content-wrapper';
import Spinner from './components/Elements/spinner';

require('intersection-observer');


export default {
  data() {
    return {
      loaded: false,
      tl: gsap.timeline().pause(),
    };
  },
  computed: {
    errors() {
      return this.$store.state.errors.list;
    },
    title() {
      if (this.$route.path === '/voted') return 'Merci pour votre vote !';
      if (this.$route.path === '/ended') return 'Les votes sont clos.';
      return 'Votez pour la meilleure série en compétition !';
    },
    text() {
      if (this.$route.path === '/voted') {
        return `Votre participation a bien été prise en compte.<br />
                Rendez-vous demain pour voter à nouveau !<br /><br />
                Ne ratez pas le vote pour la meilleure série en compétition du 9 au 13 octobre !`;
      }
      if (this.$route.path === '/ended') return 'Rendez-vous le 1er Avril pour découvrir les résultats !';
      return `Festival International des Séries de Cannes qui
        se tiendra du 27 mars au 1er avril prochain,
        vous pouvez voter pour votre série française
        préférée de l’année.<br /><br />
        La série gagnante sera révélée le 1er avril
        lors de la cérémonie de clôture du Festival, diffusée en exclusivité et en clair sur CANAL+.`;
    },
  },
  components: {
    MyCanalFooter,
    // MyCanalHeader,
    AppHero,
    ContentWrapper,
    Spinner,
  },
  watch: {
    $route() {
      if (!this.loaded) this.animateIn();
      this.loaded = true;
    },
  },
  methods: {
    goToVotes() {
      const votesPositionY = document.getElementById('votes').getBoundingClientRect().top;
      window.scrollTo({
        top: votesPositionY,
        left: 0,
        behavior: 'smooth',
      });
    },
    animateIn() {
      this.tl.fromTo('.slide-up', { y: 100, opacity: 0 }, {
        y: 0, opacity: 1, duration: 1, stagger: 0.1, ease: 'power3.inOut',
      }, 0.4);

      this.tl.fromTo('.slide-left', { x: 400, opacity: 0 }, {
        x: 0, opacity: 1, duration: 1, stagger: 0.1, ease: 'power3.inOut',
      }, 0.6);
      this.tl.play();
    },
    entered(e) {
      gsap.fromTo(`.${e}`, { opacity: 0, y: 100 }, {
        opacity: 1, y: 0, stagger: 0.1, duration: 1, ease: 'power3.inOut',
      });
    },
  },
  mounted() {
    if (this.$route.name != null) this.loaded = true;
    gsap.set('.will-appear', { opacity: 0 });
  },
};
</script>

<style lang="scss">
.app {

  &__errors {
    position: fixed;
    top: 60px;
    left: 50%;
    transform: translate(-50%, 0);
    min-height: 20px;
    background: #ec3554;
    z-index: 9;
    padding: 10px 20px;
    border-radius: 5px;
  }

  &__title {
    text-align: left;
    font-size: 50px !important;
    margin-top: 50px;
    // margin-bottom: 30px;
    // flex-grow: 1;
    // z-index: 4;
  }

  &__logo {
    width: 100%;
  }

  &__spinner {
    z-index: 5;
  }

  &__loading {
    position: fixed;
    height: 100vh;
    width: 100vw;
    background: var(--color-gray);
    z-index: 9;
    transition: opacity .4s;
    pointer-events: none;
    touch-action: none;
    top: 0;
    left: 0;
  }

  &__partner {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: var(--spacing-l) 0 var(--spacing-s) 0;
    color: var(--color-black);

    img {
      margin-left: 15px;
      height: 45px;
    }
  }

  &__textContent {
    max-width: 500px;
    margin:auto;
    text-align: center;
    padding: var(--spacing-xl) 0 var(--spacing-l) 0;

    @include media('<m') {
      padding: var(--spacing-xl) 20px var(--spacing-l) 20px;
    }

    b {
      font-weight: 800;
    }

    p {
      margin-bottom: var(--spacing-m);
    }
  }


  // &__voteText {
  //   text-align: center;
  //   margin-bottom: var(--spacing-m);
  //   grid-column: 1 / span 4;
  //   grid-row: 1 / span 1;
  //   color: var(--color-pink);

  //   @include media('>=m') {
  //     grid-column-start: 4;
  //     text-align: left;
  //   }

  //   // &--black {
  //   //   background: var(--color-white);
  //   //   color: var(--color-black);
  //   //   padding: 5px;
  //   //   display: block;
  //   // }

  // }

// .heroContent {
//     position: relative;
//     &__titleBlock {
//       position: relative;

//       @include media('<s') {
//         margin-right: auto;
//       }
//     }

//     &__blocks {
//       display: flex;
//       flex-direction: column;
//       align-items: flex-start;
//     }

//     &__best {
//       padding: var(--spacing-s);
//       background: var(--color-yellow);
//       color: var(--color-pink);
//     }

//     &__public {
//       padding: var(--spacing-s);
//       background: var(--color-white);
//       color: var(--color-pink);
//     }

//     &__scroll {
//       position: absolute;
//       top: calc(80vh);
//       display: flex;
//       width: 100%;
//       justify-content: center;
//       align-items: center;
//       animation: up-down 2s infinite cubic-bezier(.51,.07,.52,.99);
//       z-index: 9;
//       flex-direction: column;
//       cursor: pointer;

//       @include media('<s') {
//         top: calc(100vh - 210px);
//       }

//       @media(max-height: 590px) {
//         top: calc(100vh - 180px);
//       }
//     }

//     &__arrow {
//       border-right: 3px solid var(--color-white);
//       border-bottom: 3px solid var(--color-white);
//       height: 20px;
//       width: 20px;
//       transform: rotate(45deg);
//     }

//     &__dateBlock {
//       text-align: right;

//       @include media('<s') {
//         margin-bottom: var(--spacing-s);
//       }
//     }

//     &__public, &__best, &__dateBlock {
//       p {
//         font-size: var(--font-size-l);
//       }

//       @include media('<s') {
//         padding-left: 25px;
//       }
//     }

//     &__hashtag--mobile {
//       width: 100%;
//       margin: 15px 0;
//       text-align: center;
//     }

//     &__hashtag--mobile {
//       display: none;
//     }
//   }

//   &__heroContainer {
//       width: 100%;
//       margin: 0 10% 50px 10%;
//       display: flex;
//       flex-direction: column;
//       align-items: flex-end;

//         @include media('<l') {
//           margin-bottom: 100px;
//         }

//         @include media('<s') {
//           margin: 0 10px 50px 0px;
//           width: 100%;
//           margin-bottom: 100px;
//         }

//         h1 {
//           font-family:"Helvetica Neue Black";
//           font-size: var(--font-size-l);
//           text-align: right;

//           span {
//             color: var(--color-yellow);
//           }
//         }
//   }

//   &__heroContent {
//         z-index: 4;
//         display: flex;
//         flex-grow: 1;
//         justify-content: space-between;
//         width: 100%;

//         @include media('<s') {
//           flex-direction: column-reverse;
//         }
//     }
}


@keyframes up-down {
  0% {
    transform: translateY(0);
    opacity: 0;
  }

  50% {
    transform: translateY(10px);
    opacity: 1;
  }

  100% {
    transform: translateY(0px);
    opacity: 0;
  }
}


.fade-leave-active {
  transition: opacity .5s cubic-bezier(.51,.07,.52,.99);
}
.fade-leave-to {
  opacity: 0;
}


.fade-in-out-leave-active, .fade-in-out-enter-active {
  transition: opacity .5s cubic-bezier(.51,.07,.52,.99);
}
.fade-in-out-leave-to, .fade-in-out-enter {
  opacity: 0;
}

.slide-leave-active, .slide-enter-active {
  transition: transform .5s cubic-bezier(.51,.07,.52,.99);
}
.slide-leave-to, .slide-enter {
  transform: translate(-50%, -200px);
}
</style>
